export const FLAG_DOCTOR_NOT_LISTED = 1;
export const FLAG_UNSURE_WHICH_DOCTOR = 2;

export default {
  FLAG_DOCTOR_NOT_LISTED,
  FLAG_UNSURE_WHICH_DOCTOR
};
